const COLORS = {
  CORRECT: "#5AD14F",
  INCORRECT: "#FA4E44",
};

const COLLEGES = [
  "Pittsburgh",
  "Wisconsin",
  "Nebraska",
  "Clemson",
  "Tennessee",
  "Notre Dame",
  "Florida State",
  "Michigan",
  "Texas A&M",
  "Texas",
  "Penn State",
  "Auburn",
  "Michigan State",
  "Louisiana State",
  "Ohio State",
  "Georgia",
  "Oregon",
  "Southern California",
  "Stanford",
  "Miami",
  "California",
  "Washington",
  "North Carolina",
  "UCLA",
  "Arizona State",
  "Oklahoma",
  "Alabama",
  "Florida",
  "Iowa",
];

const USER = "./assets/USER.png";

const IMAGES_COLLEGES = [
  "./assets/COLLEGE_TEAMS/Pittsburgh.png",
  "./assets/COLLEGE_TEAMS/Wisconsin.png",
  "./assets/COLLEGE_TEAMS/Nebraska.png",
  "./assets/COLLEGE_TEAMS/Clemson.png",
  "./assets/COLLEGE_TEAMS/Tennessee.png",
  "./assets/COLLEGE_TEAMS/NotreDame.png",
  "./assets/COLLEGE_TEAMS/FloridaState.png",
  "./assets/COLLEGE_TEAMS/Michigan.png",
  "./assets/COLLEGE_TEAMS/TexasAM.png",
  "./assets/COLLEGE_TEAMS/Texas.png",
  "./assets/COLLEGE_TEAMS/PennState.png",
  "./assets/COLLEGE_TEAMS/Auburn.png",
  "./assets/COLLEGE_TEAMS/MichiganState.png",
  "./assets/COLLEGE_TEAMS/LouisianaState.png",
  "./assets/COLLEGE_TEAMS/OhioState.png",
  "./assets/COLLEGE_TEAMS/Georgia.png",
  "./assets/COLLEGE_TEAMS/Oregon.png",
  "./assets/COLLEGE_TEAMS/SouthernCalifornia.png",
  "./assets/COLLEGE_TEAMS/Stanford.png",
  "./assets/COLLEGE_TEAMS/Miami.png",
  "./assets/COLLEGE_TEAMS/California.png",
  "./assets/COLLEGE_TEAMS/Washington.png",
  "./assets/COLLEGE_TEAMS/NorthCarolina.png",
  "./assets/COLLEGE_TEAMS/UCLA.png",
  "./assets/COLLEGE_TEAMS/ArizonaState.png",
  "./assets/COLLEGE_TEAMS/Oklahoma.png",
  "./assets/COLLEGE_TEAMS/Alabama.png",
  "./assets/COLLEGE_TEAMS/Florida.png",
  "./assets/COLLEGE_TEAMS/Iowa.png",
];

const NFL_TEAMS = [
  "MIA",
  "NYJ",
  "GB",
  "DET",
  "TEN",
  "NO",
  "MIN",
  "CAR",
  "LV",
  "DEN",
  "CLE",
  "ARI",
  "KC",
  "CIN",
  "TB",
  "CHI",
  "NE",
  "JAX",
  "ATL",
  "PHI",
  "HOU",
  "SEA",
  "LAC",
  "LA",
  "NYG",
  "DAL",
  "SF",
  "PIT",
  "BUF",
  "IND",
  "BAL",
  "WAS",
];

const IMAGES_NFL_TEAMS = [
  "./assets/NFL_TEAMS/MIA.png",
  "./assets/NFL_TEAMS/NYJ.png",
  "./assets/NFL_TEAMS/GB.png",
  "./assets/NFL_TEAMS/DET.png",
  "./assets/NFL_TEAMS/TEN.png",
  "./assets/NFL_TEAMS/NO.png",
  "./assets/NFL_TEAMS/MIN.png",
  "./assets/NFL_TEAMS/CAR.png",
  "./assets/NFL_TEAMS/LV.png",
  "./assets/NFL_TEAMS/DEN.png",
  "./assets/NFL_TEAMS/CLE.png",
  "./assets/NFL_TEAMS/ARI.png",
  "./assets/NFL_TEAMS/KC.png",
  "./assets/NFL_TEAMS/CIN.png",
  "./assets/NFL_TEAMS/TB.png",
  "./assets/NFL_TEAMS/CHI.png",
  "./assets/NFL_TEAMS/NE.png",
  "./assets/NFL_TEAMS/JAX.png",
  "./assets/NFL_TEAMS/ATL.png",
  "./assets/NFL_TEAMS/PHI.png",
  "./assets/NFL_TEAMS/HOU.png",
  "./assets/NFL_TEAMS/SEA.png",
  "./assets/NFL_TEAMS/LAC.png",
  "./assets/NFL_TEAMS/LA.png",
  "./assets/NFL_TEAMS/NYG.png",
  "./assets/NFL_TEAMS/DAL.png",
  "./assets/NFL_TEAMS/SF.png",
  "./assets/NFL_TEAMS/PIT.png",
  "./assets/NFL_TEAMS/BUF.png",
  "./assets/NFL_TEAMS/IND.png",
  "./assets/NFL_TEAMS/BAL.png",
  "./assets/NFL_TEAMS/WAS.png",
];

const POSITIONS = [
  "DT",
  "RB",
  "WR",
  "DE",
  "DB",
  "LB",
  "OG",
  "C",
  "OT",
  "TE",
  "K",
  "P",
  "DL",
  "QB",
  "KR",
  "OL",
];
export default {
  COLORS,
  COLLEGES,
  NFL_TEAMS,
  POSITIONS,
  IMAGES_COLLEGES,
  IMAGES_NFL_TEAMS,
  USER,
};
